export default __webpack_public_path__ + "static/media/deafualt-image.0a63f821.jpg";